// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"312":"925b6d2a","629":"a74f2e7e","862":"720b138d"}[chunkId] + ".chunk.css";
};